module.exports = __webpack_public_path__ + "img/1-1.c9150ac1.jpg";